import { render, staticRenderFns } from "./ByproductSummaries.vue?vue&type=template&id=2ee30f35&"
import script from "./ByproductSummaries.vue?vue&type=script&lang=js&"
export * from "./ByproductSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports